import React from 'react';
import clsx from 'clsx';
import { DivPropsWithoutRef } from '../common/types';

export enum ProgressBarSize {
  small = 'small',
  medium = 'medium'
}

export interface ProgressBarProps extends Omit<DivPropsWithoutRef, 'size'> {
  /**
   * Размер (`small`, `medium`)
   */
  size?: ProgressBarSize;
  /**
   * Значение ProgressBar - число от 0 до 100. Любое число меньше 0 считается эквивалентным 0, любое число больше 100 - эквивалентным 100.
   */
  value?: number;
  /**
   * Добавляет бесконечную загрузку
   */
  indeterminate?: boolean;
  /**
   * Произвольные классы
   */
  classes?: {
    fill?: string;
  };
}

export function ProgressBar({
  size = ProgressBarSize.medium,
  value = 0,
  indeterminate,
  className,
  classes,
  ...props
}: ProgressBarProps) {
  const fillWidth = value < 0 ? '0' : value > 100 ? '100%' : value + '%';
  return (
    <div
      className={clsx(className, 'hse-ProgressBar', {
        'hse-ProgressBar_size_small': size === ProgressBarSize.small,
        'hse-ProgressBar_indeterminate': indeterminate
      })}
      {...props}
    >
      <div
        className={clsx('hse-ProgressBar__fill', classes?.fill)}
        style={{ width: fillWidth }}
      />
      {indeterminate ? (
        <div className={'hse-ProgressBar__indeterminate'}>
          <div
            className={
              'hse-ProgressBar__indeterminateLine hse-ProgressBar__indeterminateLine_short'
            }
          />
          <div
            className={
              'hse-ProgressBar__indeterminateLine hse-ProgressBar__indeterminateLine_long'
            }
          />
        </div>
      ) : null}
    </div>
  );
}
